import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/blog.css";
import ContactForm from "../components/ContactForm";
import { getAllBlogs, getSingleBlog } from "../api/blog.api";


const BlogDetails = () => {
  const [blogs, setBlogs] = useState([]);

  const dummyBlog = {
    title: "This is a Test Blog",
    content: `
          <p>Welcome to our blog!</p>
          <p>[form]</p>
          <p>We're glad you're here.</p>
          <p>Let us know if you have any questions.</p>
        `,
  };

  const renderContentWithForm = () => {
    const parts = blogs?.content?.split("[form]");
    // console.log("parts", parts);
    return parts?.map((part, index) => (
      <React.Fragment key={index}>
        <div dangerouslySetInnerHTML={{ __html: part }} />
        {index !== parts.length - 1 && <ContactForm />}
      </React.Fragment>
    ));
  };

  useEffect(() => {
    const fetchBlogs = async () => {
      const blogId = "67fa31f0fba0c02d082bca30";
      try {
        const { data } = await getSingleBlog(blogId);
        setBlogs(data);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchBlogs();
  }, []);

  console.log("blog", blogs);

  

  return (
    <div>
      <header className="navbar">
        <Navbar />
      </header>

      <main>
        <section>
          <div
            className="blog-banner"
            style={{
              backgroundImage: `url(http://localhost:8000/${blogs.featuredImage})`,
            }}
          >
            <h1 className="text-4xl font-bold mb-2">{blogs?.title}</h1>
          </div>
        </section>
        <div className="container banner-wrapper">
          <div className="row">
            <div className="col-lg-4"></div>
            <div className="col-lg-8">
              {renderContentWithForm()}
              {blogs ? (
                <div className="max-w-4xl mx-auto px-4 py-8">
                  <p className="text-gray-600 text-sm mb-4">
                    Category: {blogs?.category}
                  </p>
                  <div className="flex gap-2 mb-6">
                    {blogs?.keywords?.map((tag, i) => (
                      <span
                        key={i}
                        className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-sm"
                      >
                        #{tag}
                      </span>
                    ))}
                  </div>
                  <div
                    className="prose prose-lg max-w-none"
                    dangerouslySetInnerHTML={{ __html: blogs?.content }}
                  />
                </div>
              ) : (
                <div class="spinner-border text-danger" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <footer className="footer">
        <Footer />
      </footer>
    </div>
  );
};

export default BlogDetails;
